import React from 'react';

const Spinner = (props) => {
    return <div className="spinner-overlay">{props.show && <div className="spinner-container">{props.children}</div>}</div>;
};

export default Spinner;
